export default __webpack_public_path__ + "13370d09d7675bdd417aa0ade94c546d.png";